import * as React from "react";
import Manage from "../../assets/icons/input-cursor-text.svg";
import Icon from "./Icon";

const RenameIcon = () => {
    var smallStyle = {
        height: 18,
        margin: "0px 8px 0px 0px" 
    }; 

  return (
    <React.Fragment>
          <Icon icon={Manage} text="Rename" id="renameIcon" style={smallStyle} tooltip={true}/>
    </React.Fragment>
  );
};

export default RenameIcon;
